import useEventCallback from '@unifyapps/hooks/useEventCallback';
import { fetchUserDetails } from '../../../../../auth/hooks/useGetCurrentUserDetails';
import { useUserStore } from '../../../../../auth/UserStoreProvider';
import { useSetDeviceContext } from '../../../../components/app/InterfaceAppRunnerSideEffects/hooks/helperHooks/useSetDeviceContext';
import { useSetUserDetailsAndContext } from '../../../../components/app/InterfaceAppRunnerSideEffects/hooks/helperHooks/useSetUserDetailsAndContext';
import { getUserDetails, useGetUserContext } from '../../../../hooks/useGetUserContext';
import { adaptUserExtraContextToDeviceContext } from '../../../../utils/deviceContextAdapters';
import { useUserRuntimeEnvDetails } from '../../../useUserContext/useUserRuntimeEnvDetails';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';

export default function useRefreshUserContext() {
  const { context: userRuntimeEnvDetails } = useUserRuntimeEnvDetails();
  const { setCurrentUserRuntimeEnvDetails } = useUserStore().hooks.useActions();
  const { setUserDetailsAndContext } = useSetUserDetailsAndContext();
  const { setDeviceContext } = useSetDeviceContext();
  const { userContext } = useGetUserContext();

  const onRefreshUserContext = useEventCallback(async () => {
    const fetchedUserAndUserRuntimeEnvDetails = await fetchUserDetails(userRuntimeEnvDetails);
    const { userDetails, userRuntimeEnvDetails: fetchedUserRuntimeEnvDetails } =
      fetchedUserAndUserRuntimeEnvDetails ?? {};

    if (!userDetails) {
      return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    }

    const userDetailsForContext = getUserDetails(userDetails.user);
    const updatedUserContext = {
      ...userContext,
      ...userDetailsForContext,
    };

    setUserDetailsAndContext({
      userDetails,
      userContext: updatedUserContext,
    });
    // the server exchange keeps the legacy shape; adapt into the device slice.
    // when the fetch yields no env the write is skipped — the existing slice is
    // deliberately RETAINED (a refresh should not wipe device data it didn't
    // re-measure)
    const refreshedDeviceContext = adaptUserExtraContextToDeviceContext(
      fetchedUserRuntimeEnvDetails,
    );
    if (refreshedDeviceContext) {
      setDeviceContext(refreshedDeviceContext);
    }
    setCurrentUserRuntimeEnvDetails(fetchedUserRuntimeEnvDetails);

    return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
  });

  return {
    onRefreshUserContext,
  };
}
